import { Component, Element, Event, EventEmitter, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'biel-search-button',
  styleUrl: 'biel-search-button.css',
  shadow: true,
})
export class BielSearchButton {

  bielSearch: any;
  @Element() el: HTMLElement;
  @Prop() customFont: boolean = false;
  @Prop() project: string = '';
  @Prop() buttonStyle: string = 'default';
  @Prop() modalPosition: string = 'top-center';
  @Prop() headerTitle: string = 'Company Name AI';
  @Prop() hideIcon: boolean = false;
  @Prop() hideCtrlK: boolean = false;
  @Prop() hideFeedback: boolean = false;
  @Prop() hideExpandButton: boolean = false;
  @Prop() errorMessage404: string = "Oops! We could not find the provided project ID.";
  @Prop() errorMessage403: string = "Oops! The request URL does not match the one defined for this project.";
  @Prop() errorMessageDefault: string = "Oops! Please try again later.";
  @Prop() footerText: string = "AI-generated answers may contain errors. Verify official sources before use.";
  @Prop() searchPlaceholder: string = "Search or ask AI...";
  @Prop() hideFilters: boolean = true;

  @Event() bielSearchButtonClick: EventEmitter<void>;

  connectedCallback() {
    this.bielSearch = document.createElement('biel-search');
    const props = [
      'customFont',
      'project',
      'modalPosition',
      'errorMessage404',
      'errorMessage403',
      'errorMessageDefault',
      'searchPlaceholder',
      'headerTitle',
      'hideFilters',
      'hideFeedback',
      'hideExpandButton',
      'footerText',
    ];

    props.forEach(prop => {
      this.bielSearch[prop] = this[prop];
    });

    document.body.appendChild(this.bielSearch);
  }

  disconnectedCallback() {
    document.body.removeChild(this.bielSearch);
  }

  componentDidLoad() {
    if (!this.customFont) {
      this.loadInterFont();
    }
    if (!this.hideCtrlK) {
      window.addEventListener('keydown', this.handleKeyPress);
    }
  }

  loadInterFont() {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }

  showSearchModal() {
    this.bielSearch.showSearchModal = true;
    this.bielSearchButtonClick.emit();
  }

  handleKeyPress = (event: KeyboardEvent) => {
    if (event.ctrlKey && (event.key === 'k' || event.key === 'K')) {
      event.preventDefault();
      this.showSearchModal();
    }
  };

  render() {
    return (
      <Host>
        <a class={`biel-search-button-content biel-search-button-content--${this.buttonStyle}`} onClick={() => this.showSearchModal()}>
          {!this.hideIcon && (
            <span class="biel-search-button-content-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /></svg>
            </span>
          )}
          <slot />
          {!this.hideCtrlK && (
            <span class="biel-search-button-content-ctrl-k">
              CTRL+K
            </span>
          )}
        </a>
      </Host>
    );
  }
}
